module.exports = __webpack_public_path__ + "static/media/object_sensor_labels.1a677a26.jpg";